import { render, staticRenderFns } from "./Valentes.vue?vue&type=template&id=6230a568&scoped=true"
import script from "./Valentes.vue?vue&type=script&lang=js"
export * from "./Valentes.vue?vue&type=script&lang=js"
import style0 from "./Valentes.vue?vue&type=style&index=0&id=6230a568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6230a568",
  null
  
)

export default component.exports